/** Steps of the getting-started checklist; mirrors the API's `IOnboardingSteps`. */
export interface IOnboardingSteps {
    sessionCreated: boolean;
    playerAdded: boolean;
    historyViewed: boolean;
    calendarEventCreated: boolean;
}

export interface IOnboardingStatus {
    steps: IOnboardingSteps;
    /** The coach closed the checklist for good. */
    dismissed: boolean;
    /** The co-coach's onboarding step still to show, as on the account; absent until it started. */
    tourStep?: OnboardingTourStep;
    /** Messages of the co-coach shown once per coach that the coach has seen, on any device. */
    sidekickSeen?: string[];
}

export interface IOnboardingStepDef {
    /** `accountCreated` is not tracked: every signed-in coach has done it. */
    key: keyof IOnboardingSteps | 'accountCreated';
    /** Translation key prefix: `<prefix>.title` and `<prefix>.hint`. */
    label: string;
    route: string[];
}

/**
 * Where the co-coach's onboarding stands: the birth, the steps of the guided session, then done.
 * Each value is the step still to show; mirrors the API's `OnboardingTourStep`.
 */
export const ONBOARDING_TOUR_STEPS = ['birth', 'checklist', 'switch', 'options', 'players', 'comment', 'done'] as const;
export type OnboardingTourStep = (typeof ONBOARDING_TOUR_STEPS)[number];

/** The later of two onboarding steps: the onboarding only moves on, whichever device saw what. */
export function laterTourStep(a: OnboardingTourStep, b: OnboardingTourStep | undefined): OnboardingTourStep {
    return b && ONBOARDING_TOUR_STEPS.indexOf(b) > ONBOARDING_TOUR_STEPS.indexOf(a) ? b : a;
}
